export default "__VITE_ASSET__BFfR6Uqi__"